import icon from '@/assets/icon.webp';

const imageHandler = {
    /**
     * Gets default icon
     * @returns 
     */
    defaultIcon() {
        return icon;
    },

    /**
     * Gets image on public folder
     * @param {String} fileName 
     * @returns 
     */
    getOnPublic(fileName = ''){
        return `${process.env.VUE_APP_BASE_URL}${fileName}`;
    },

    toBase64Img(src = '') {
        let photo = this.defaultIcon();
        if (![null, '', undefined].includes(src)) {
            photo = src.indexOf('data:image/png;base64,') == 0 ? src : `data:image/png;base64,${src}`;
        }
        return photo;
    },

    /**
     * Gets all file icons
     * @returns {object}
     */
    getFileIcons() {
        return {
            // Documentos
            pdf: 'pi pi-file-pdf',
            doc: 'pi pi-file-word',
            docx: 'pi pi-file-word',
            xls: 'pi pi-file-excel',
            xlsx: 'pi pi-file-excel',
            ppt: 'pi pi-file-powerpoint',
            pptx: 'pi pi-file-powerpoint',
            txt: 'pi pi-file-edit',
            
            // Imagens
            jpg: 'pi pi-image',
            jpeg: 'pi pi-image',
            png: 'pi pi-image',
            gif: 'pi pi-image',
            svg: 'pi pi-image',
            
            // Vídeos
            mp4: 'pi pi-video',
            mkv: 'pi pi-video',
            mov: 'pi pi-video',
            avi: 'pi pi-video',
            
            // Áudio
            mp3: 'pi pi-volume-up',
            wav: 'pi pi-volume-up',
            ogg: 'pi pi-volume-up',
            
            // Compactados
            zip: 'pi pi-box',
            rar: 'pi pi-box',
            '7z': 'pi pi-box',
            
            // Código
            html: 'pi pi-code',
            css: 'pi pi-code',
            js: 'pi pi-code',
            json: 'pi pi-code',
            
            // Default
            default: 'pi pi-file'
        };
    },

    /**
     * Gets file icon
     * @param {string} name 
     * @returns {string}
     */
    getFileIcon(name = '') {
        const all = this.getFileIcons();

        return all[name] != undefined ? all[name] : all.default;
    }
}

export default imageHandler;